var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    id: "Layer_1",
    viewBox: "0 0 413 413",
    width: 413,
    height: 413,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#29a71a",
    height: 412.22,
    rx: 55.43,
    width: 412.22,
    x: 1.1582317,
    y: 0.52535164
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 79.088232,329.34535 25.179998,-65.71 a 125.52,125.52 0 1 1 41.78,40.24 z m 72.179998,-44.37 2.27,1.42 a 105.31,105.31 0 1 0 -32,-30.74 l 1.57,2.34 -16.84,44.12 z",
    fill: "#fefefe"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m 268.40823,218.97535 c -11.59,-6 -23.91,-11.56 -24,-11.61 -4.24,-2 -7.22,0.23 -8.14,1.56 l -9.64,12 c -2.6,2.28 -6.22,0 -6.62,-0.24 a 79.36,79.36 0 0 1 -38.41,-33.64 c -2,-2.56 -0.25,-4.23 0.13,-4.55 v 0 c 4,-3.46 7.69,-9.35 7.83,-9.58 2.39,-3.74 0.25,-8.39 0.18,-8.54 l -10.35,-23.95 c -2.45,-4.67 -8,-3.87 -8.08,-3.84 h -4.11 a 9,9 0 0 0 -7.49,2.26 v 0 a 34.85,34.85 0 0 0 -10.8,14.28 43.77,43.77 0 0 0 5.59,38.37 c 17.78,28.79 34.89,40.31 35.57,40.75 24,17.54 48.08,20 49,20.08 a 29.94,29.94 0 0 0 4.05,0.27 32,32 0 0 0 22.48,-9.73 c 5.58,-4.81 6.45,-15.65 6.48,-16.21 0.03,-6.02 -3.62,-7.66 -3.67,-7.68 z",
    fill: "#fefefe"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.43cd3e5f3c3d045c079065e85119b4e1.svg";
export { ForwardRef as ReactComponent };